/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';

export const EmailShareIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    version="1.1"
    id="imgView"
    x="0px"
    y="0px"
    viewBox="0 0 27.857 27.857"
    enableBackground="new 0 0 27.857 27.857;"
    xmlSpace="preserve"
  >
    <g>
      <g>
        <path
          d="M2.203,5.331l10.034,7.948c0.455,0.36,1.082,0.52,1.691,0.49c0.608,0.03,1.235-0.129,
                1.69-0.49l10.034-7.948c0.804-0.633,0.622-1.152-0.398-1.152H13.929H2.604C1.583,4.179,1.401,4.698,2.203,
                5.331z"
        />

        <path
          d="M26.377,7.428l-10.965,8.325c-0.41,0.308-0.947,0.458-1.482,0.451
                c-0.536,0.007-1.073-0.144-1.483-0.451L1.48, 7.428C0.666,6.811,0,7.142,0,8.163v13.659c0,1.021,0.836,
                1.857,1.857,1.857h12.071H26 c1.021,0,1.857-0.836,1.857-1.857V8.163C27.857,7.142,27.191,
                6.811,26.377,7.428z"
        />
      </g>
    </g>
  </svg>
);

export const GooglePlusShareIcon = () => (
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 96.828 96.827"
    enableBackground="new 0 0 96.828 96.827"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M62.617,0H39.525c-10.29,0-17.413,2.256-23.824,7.552c-5.042,4.35-8.051,10.672-8.051,16.912 c0,9.614,
                7.33,19.831,20.913,19.831c1.306,0,2.752-0.134,4.028-0.253l-0.188,0.457c-0.546,1.308-1.063,2.542-1.063,4.468 c0,
                3.75,1.809,6.063,3.558,8.298l0.22,0.283l-0.391,0.027c-5.609,0.384-16.049,1.1-23.675,5.787 c-9.007,5.355-9.707,
                13.145-9.707,15.404c0,8.988,8.376,18.06,27.09,18.06c21.76,0,33.146-12.005,33.146-23.863
                c0.002-8.771-5.141-13.101-10.6-17.698l-4.605-3.582c-1.423-1.179-3.195-2.646-3.195-5.364c0-2.672,1.772-4.436,
                3.336-5.992 l0.163-0.165c4.973-3.917,10.609-8.358,10.609-17.964c0-9.658-6.035-14.649-8.937-17.048h7.663c0.094,
                0,0.188-0.026,0.266-0.077 l6.601-4.15c0.188-0.119,0.276-0.348,0.214-0.562C63.037,0.147,62.839,0,62.617,
                0z M34.614,91.535 c-13.264,0-22.176-6.195-22.176-15.416c0-6.021,3.645-10.396,10.824-12.997c5.749-1.935,
                13.17-2.031,13.244-2.031 c1.257,0,1.889,0,2.893,0.126c9.281,6.605,13.743,10.073,13.743,16.678C53.141,86.309,
                46.041,91.535,34.614,91.535z M34.489,40.756c-11.132,0-15.752-14.633-15.752-22.468c0-3.984,0.906-7.042,
                2.77-9.351c2.023-2.531,5.487-4.166,8.825-4.166 c10.221,0,15.873,13.738,15.873,23.233c0,1.498,0,6.055-3.148,
                9.22C40.94,39.337,37.497,40.756,34.489,40.756z"
      />
      <path
        d="M94.982,45.223H82.814V33.098c0-0.276-0.225-0.5-0.5-0.5H77.08c-0.276,0-0.5,0.224-0.5,0.5v12.125H64.473
              c-0.276,0-0.5,0.224-0.5,0.5v5.304c0,0.275,0.224,0.5,0.5,0.5H76.58V63.73c0,0.275,0.224,0.5,0.5,0.5h5.234 c0.275,
              0,0.5-0.225,0.5-0.5V51.525h12.168c0.276,0,0.5-0.223,0.5-0.5v-5.302C95.482,45.446,95.259,45.223,94.982,45.223z"
      />
    </g>
  </svg>
);

export const TwitterShareIcon = () => (
  <svg
    version="1.1"
    id="TWicon"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 18.001 18.001"
    enableBackground="new 0 0 18.001 18.001"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M15.891,4.013c0.808-0.496,1.343-1.173,1.605-2.034c-0.786,0.417-1.569,0.703-2.351,0.861
              c-0.703-0.756-1.593-1.14-2.66-1.14c-1.043,0-1.924,0.366-2.643,1.078C9.127,3.495,8.766,4.366,8.766,5.383 c0,
              0.309,0.039,0.585,0.117,0.819C5.807,6.097,3.261,4.821,1.255,2.365c-0.34,0.601-0.51,1.213-0.51,1.846 c0,1.301,
              0.549,2.332,1.645,3.089C1.765,7.247,1.214,7.089,0.745,6.83c0,0.929,0.273,1.705,0.82,2.388 c0.549,0.676,1.254,
              1.107,2.115,1.291c-0.312,0.08-0.641,0.118-0.979,0.118c-0.312,0-0.533-0.026-0.664-0.083 c0.23,0.757,0.664,1.371,
              1.291,1.841c0.625,0.472,1.344,0.721,2.152,0.743c-1.332,1.045-2.855,1.562-4.578,1.562 c-0.422,
              0-0.721-0.006-0.902-0.038c1.697,1.102,3.586,1.649,5.676,1.649c2.139,0,4.029-0.542,5.674-1.626 c1.645-1.078,
              2.859-2.408,3.639-3.974c0.784-1.564,1.172-3.192,1.172-4.892V5.341c0.758-0.57,1.371-1.212,1.84-1.921 C17.321,
              3.713,16.618,3.912,15.891,4.013z"
      />
    </g>
  </svg>
);

export const FbShareIcon = () => (
  <svg
    version="1.1"
    id="FBicon"
    fill="currentColor"
    xmlns="https://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 23.101 23.101"
    enableBackground="new 0 0 23.101 23.101"
    xmlSpace="preserve"
  >
    <g>
      <path
        d="M8.258,4.458c0-0.144,0.02-0.455,0.06-0.931c0.043-0.477,0.223-0.976,0.546-1.5c0.32-0.522,0.839-0.991,
              1.561-1.406 C11.144,0.208,12.183,0,13.539,0h3.82v4.163h-2.797c-0.277,0-0.535,0.104-0.768,0.309c-0.231,0.205-0.35,
              0.4-0.35,0.581v2.59h3.914 c-0.041,0.507-0.086,1-0.138,1.476l-0.155,1.258c-0.062,0.425-0.125,0.819-0.187,
              1.182h-3.462v11.542H8.258V11.558H5.742V7.643 h2.516V4.458z"
      />
    </g>
  </svg>
);

export const FbIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="14.969"
    height="31.97"
    viewBox="0 0 14.969 31.97"
  >
    <path
      fill="#3d5898"
      fillRule="evenodd"
      d="M681.739,1389.29v-3.32a1.356,1.356,0,0,1,
        1.417-1.54h3.6v-5.48l-4.955-.02c-5.5,0-6.752,4.09-6.752,
        6.71v3.65h-3.181v5.65h3.181v15.98h6.692v-15.98h4.514l0.584-5.65h-5.1Z"
      transform="translate(-671.875 -1378.94)"
    />
  </svg>
);

export const FlickrIcon = () => (
  <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 31.65 13.94">
    <circle fill="#ee3b95" cx="24.68" cy="6.97" r="6.97" />
    <circle fill="#367abf" cx="6.97" cy="6.97" r="6.97" />
  </svg>
);

export const InstaIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
  >
    <path
      fillRule="evenodd"
      d="M838.991,1383.52c3.74,0,4.182.02,5.659,0.09a7.747,
        7.747,0,0,1,2.6.48,4.654,4.654,0,0,1,2.658,2.66,7.686,7.686,
        0,0,1,.482,2.6c0.068,1.47.082,1.92,0.082,5.65s-0.014,
        4.19-.082,5.66a7.686,7.686,0,0,1-.482,2.6,4.654,4.654,0,0,
        1-2.658,2.66,7.747,7.747,0,0,1-2.6.48c-1.476.07-1.919,0.09-5.659,
        0.09s-4.182-.02-5.658-0.09a7.741,7.741,0,0,1-2.6-.48,4.647,
        4.647,0,0,1-2.658-2.66,7.686,7.686,0,0,
        1-.482-2.6c-0.068-1.47-.082-1.92-0.082-5.66s0.014-4.18.082-5.65a7.686,
        7.686,0,0,1,.482-2.6,4.647,4.647,0,0,1,2.658-2.66,7.741,7.741,
        0,0,1,2.6-.48c1.476-.07,1.919-0.09,5.658-0.09m0-2.52c-3.8,
        0-4.28.02-5.773,0.09a9.978,9.978,0,0,0-3.4.65,6.734,6.734,0,0,
        0-2.481,1.61,6.891,6.891,0,0,0-1.615,2.48,10.286,10.286,0,0,
        0-.651,3.4c-0.068,1.49-.084,1.97-0.084,5.77s0.016,4.28.084,
        5.78a10.286,10.286,0,0,0,.651,3.4,6.891,6.891,0,0,0,1.615,2.48,
        6.734,6.734,0,0,0,2.481,1.61,9.978,9.978,0,0,0,3.4.65c1.493,0.07,
        1.97.09,5.773,0.09s4.28-.02,5.774-0.09a9.978,9.978,0,0,0,3.4-.65,
        6.734,6.734,0,0,0,2.481-1.61,6.891,6.891,0,0,0,1.615-2.48,10.286,
        10.286,0,0,0,.651-3.4c0.068-1.5.084-1.97,
        0.084-5.78s-0.016-4.28-.084-5.77a10.286,10.286,0,0,0-.651-3.4,6.891,
        6.891,0,0,0-1.615-2.48,6.734,6.734,0,0,0-2.481-1.61,9.978,9.978,0,0,
        0-3.4-.65c-1.494-.07-1.97-0.09-5.774-0.09h0Zm0,6.81a7.2,7.2,0,1,0,
        7.191,7.19A7.191,7.191,0,0,0,838.991,1387.81Zm0,11.86a4.665,4.665,
        0,1,1,4.668-4.67A4.668,4.668,0,0,1,838.991,1399.67Zm9.156-12.14a1.681,
        1.681,0,1,1-1.68-1.68A1.679,1.679,0,0,1,848.147,1387.53Z"
      transform="translate(-825 -1381)"
    />
  </svg>
);

export const GoogleIcon = () => (
  <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 37.17 37.06">
    <path
      fill="#dd3e26"
      stroke="#dd3e26"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M136.13,357.22a1.16,1.16,0,0,1,.27.23q4.48,4.5,9,9c-1.88,1.85-3.73,
      3.73-5.6,5.59-0.7.71-1.42,1.4-2.11,2.13-0.52-1.26-1-2.53-1.52-3.79,
      0-1.32,0-2.63,0-4C136.12,363.37,136.11,360.3,136.13,357.22Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#ed8122"
      stroke="#ed8122"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M126.86,366.44h9.27c0,1.32,0,2.64,0,4q-0.77,1.87-1.5,
      3.75a1.66,1.66,0,0,1-.4-0.35l-7.34-7.34Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#782b8e"
      stroke="#782b8e"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M145.36,366.47l0,0q0,4.62,0,9.25h-4c-1.24-.52-2.5-1-3.75-1.51,
      0.69-.72,1.41-1.42,2.11-2.13C141.63,370.2,143.48,368.32,145.36,366.47Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#fcb813"
      stroke="#fcb813"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M125.35,368c0.52-.5,1-1,1.54-1.53l7.34,7.34a1.66,1.66,0,0,0,.4.35,
      3.05,3.05,0,0,1-.56.25c-1.07.43-2.16,0.84-3.22,1.3-1.32,0-2.65,0-4,
      0-3.08,0-6.16,0-9.25,0Q121.47,371.83,125.35,368Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#00835c"
      stroke="#00835c"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M126.87,375.7c1.32,0,2.65,0,4,0,1.25,0.51,2.5,1,3.75,1.5-2.05,
      2.08-4.13,4.14-6.19,6.21-0.52.49-1,1-1.54,1.5C126.86,381.85,126.85,
      378.77,126.87,375.7Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#4874b9"
      stroke="#4874b9"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M141.4,375.7h4c3.07,0,6.16,0,9.23,0-2,2-4,4-6,6-1.1,
      1.09-2.18,2.2-3.28,3.28-2.46-2.49-5-4.95-7.42-7.44a1.5,1.5,0,0,
      0-.33-0.27,4.51,4.51,0,0,1,.67-0.29C139.33,376.54,140.37,376.13,
      141.4,375.7Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#5cae46"
      stroke="#5cae46"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M134.59,377.21c0.53,1.26,1,2.53,1.53,3.79,0,1.32,0,2.64,0,
      4v6.37c0,0.95,0,1.9,0,2.84a1.57,1.57,0,0,
      1-.37-0.33q-4.44-4.46-8.88-8.91c0.55-.46,1-1,1.54-1.5C130.46,381.35,
      132.54,379.29,134.59,377.21Z"
      transform="translate(-117.54 -357.16)"
    />
    <path
      fill="#353b96"
      stroke="#353b96"
      strokeMiterlimit="22.93"
      strokeWidth="0.07"
      fillRule="evenodd"
      d="M137.62,377.25a1.5,1.5,0,0,1,.33.27c2.47,2.49,5,4.95,7.42,
      7.44h-9.25c0-1.32,0-2.64,0-4C136.61,379.75,137.13,378.51,137.62,377.25Z"
      transform="translate(-117.54 -357.16)"
    />
  </svg>
);

export const AddPhotoIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 35.8 27.6"
    enableBackground="new 0 0 35.8 27.6;"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#0099CC"
        d="M24.5,6.9c1.3,0,2.5,0,3.8,0c1.3,0,2.2,0.6,2.9,1.7c0.3,0.5,0.4,
          1.1,0.4,1.7c0,3.2,0,6.5,0,9.7c0,1.8-1.5,3.3-3.3,3.3c-6.3,0-12.7,
          0-19,0c-1.8,0-3.3-1.5-3.3-3.3c0-3.3,0-6.5,0-9.8c0-1.7,1.4-3.2,
          3.2-3.3c1.2,0,2.4,0,3.6,0c0.1,0,0.3,0,0.4,0c0-0.3,0.1-0.6,
          0.1-0.8c0.4-1.5,1.7-2.5,3.2-2.5c1.5,0,3.1,0,4.6,0c1.8,0,3.2,
          1.4,3.3,3.2C24.4,6.8,24.4,6.8,24.5,6.9z M18.9,9.2c-3.3,0-5.9,
          2.6-5.9,5.9c0,3.2,2.7,5.9,5.9,5.9c3.2,0,5.9-2.6,5.9-5.9C24.7,
          11.8,22,9.2,18.9,9.2z"
      />
      <path
        fill="#0099CC"
        d="M18.8,18.4c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3c1.8,
          0,3.3,1.5,3.3,3.3C22.1,16.8,20.6,18.4,18.8,18.4z"
      />
    </g>
  </svg>
);

export const AddVideoIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 39.2 30.3"
    enableBackground="new 0 0 39.2 30.3"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#0099CC"
        d="M16.9,6.6c3.2,0,6.5,0,9.7,0c0.9,0,1.2,0.2,1.2,1.2c0,4.7,0,9.4,
          0,14c0,0.8-0.3,1.1-1.1,1.1c-6.5,0-13.1,0-19.6,0c-0.8,
          0-1.1-0.3-1.1-1.1c0-4.7,0-9.4,0-14.1c0-0.8,0.3-1.1,1.1-1.1C10.4,
          6.6,13.6,6.6,16.9,6.6z"
      />
      <path
        fill="#0099CC"
        d="M35,9.3c0,3.6,0,7.2,0,10.9c-0.8-0.1-1.6,
          0.2-2.4-0.3c-1.2-0.8-2.4-1.5-3.6-2.2c-0.2-0.1-0.3-0.3-0.3-0.5c0-1.6,
          0-3.1,0-4.7c0-0.3,0.1-0.4,0.3-0.5c1.3-0.8,2.7-1.6,4-2.4c0.1-0.1,
          0.3-0.1,0.5-0.1C34,9.3,34.5,9.3,35,9.3z"
      />
    </g>
  </svg>
);

export const LightCandleIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 40.5 31.3"
    enableBackground="new 0 0 40.5 31.3"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#0099CC"
        d="M24,14c0.4,0.4,0.6,0.8,0.6,1.3c0,3,0,6,0,8.9c0,0.5,0,1,0,
          1.4c-0.1,0.9-0.8,1.6-1.7,1.6c-1.8,0-2.5,0-4.3,0c-1.2,
          0-1.8-0.6-1.8-1.8c0-3.3,0-6.6,0-9.9c0-1.2,0.7-1.9,1.9-1.9c1.7,
          0,2.4,0,4.2,0C23.3,13.6,23.7,13.7,24,14z"
      />
      <path
        fill="#0099CC"
        d="M18.6,11.8c-0.9-1-1.1-2.1-0.4-3.4c0.5-0.9,1.1-3.2,1.7-3.9c0.5-0.6,
          1-0.5,1.5,0.1c0.7,0.8,1.3,3.1,1.7,4c0.6,1.1,0.4,2.2-0.4,3.2c-0.2,
          0.2-0.4,0.4-0.7,0.3c-1,0-1.9,0-2.9,0C19,12,18.8,11.9,18.6,11.8C18.6,
          11.9,18.6,11.8,18.6,11.8z"
      />
    </g>
  </svg>
);

export const TrashcanIcon = () => (
  <svg
    width="11px"
    height="13px"
    viewBox="0 0 11 13"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <g
      id="iPhone-7-Plus"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="05-add-caption-screen"
        transform="translate(-273.000000, -328.000000)"
        fill="#999999"
      >
        <g id="Thumbnails" transform="translate(10.000000, 79.000000)">
          <g id="Delete-Button" transform="translate(263.000000, 246.000000)">
            <g id="trashcan" transform="translate(0.000000, 3.000000)">
              <g id="noun_744232_cc">
                <path
                  d="M10.4811321,1.6877898 L7.61698113,1.6877898 L7.61698113,1.06491499 C7.61698113,0.482225657 7.11886792,0 6.51698113,
                                  0 L4.46226415,0 C3.86037736,0 3.36226415,0.482225657 3.36226415,1.06491499 L3.36226415,1.6877898 L0.518867925,
                                  1.6877898 C0.228301887,1.6877898 0,1.90880989 0,2.19010819 C0,2.47140649 0.228301887,2.69242658 0.518867925,
                                  2.69242658 L0.975471698,2.69242658 L0.975471698,11.2921175 C0.975471698,12.236476 1.76415094,13 2.73962264,13 L8.23962264,
                                  13 C9.21509434,13 10.0037736,12.236476 10.0037736,11.2921175 L10.0037736,2.69242658 L10.4811321,2.69242658 C10.7716981,
                                  2.69242658 11,2.47140649 11,2.19010819 C11,1.90880989 10.7716981,1.6877898 10.4811321,1.6877898 Z M4.42075472,
                                  1.06491499 C4.42075472,1.04482226 4.44150943,1.00463679 4.48301887,1.00463679 L6.53773585,1.00463679 C6.55849057,
                                  1.00463679 6.6,1.02472952 6.6,1.06491499 L6.6,1.6877898 L4.42075472,1.6877898 L4.42075472,1.06491499 Z M8.98679245,
                                  11.2921175 C8.98679245,11.6738794 8.65471698,11.9953632 8.26037736,11.9953632 L2.76037736,11.9953632 C2.36603774,
                                  11.9953632 2.03396226,11.6738794 2.03396226,11.2921175 L2.03396226,2.69242658 L8.98679245,2.69242658 L8.98679245,
                                  11.2921175 Z"
                  id="Shape"
                />
                <path
                  d="M5.5,11 C5.78,11 6,10.78 6,10.5 L6,4.5 C6,4.22 5.78,4 5.5,4 C5.22,4 5,4.22 5,4.5 L5,10.5 C5,10.76 5.22,11 5.5,11 Z"
                  id="Shape"
                />
                <path
                  d="M7.5,11 C7.78,11 8,10.78 8,10.5 L8,4.5 C8,4.22 7.78,4 7.5,4 C7.22,4 7,4.22 7,4.5 L7,10.5 C7,10.76 7.22,11 7.5,11 Z"
                  id="Shape"
                />
                <path
                  d="M3.5,11 C3.78,11 4,10.78 4,10.5 L4,4.5 C4,4.22 3.78,4 3.5,4 C3.22,4 3,4.22 3,4.5 L3,10.5 C3,10.76 3.22,11 3.5,11 Z"
                  id="Shape"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const FlowerIcon = () => (
  <svg viewBox="0 0 15 15" xmlns="https://www.w3.org/2000/svg">
    <path
      d="M391.85,294.31a1.41,1.41,0,0,1,1.05.52,5.1,5.1,0,0,1,1.14,2.43,0.65,0.65,0,0,1-.8.83,4.77,4.77,0,0,
          1-2.52-1.21,1.43,1.43,0,0,1-.35-1.64A1.53,1.53,0,0,1,391.85,294.31Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M400.18,305.79a1.43,1.43,0,0,1-1-.5,5.09,5.09,0,0,1-1.16-2.42,0.67,0.67,0,0,1,.85-0.85,5,5,0,0,1,2.42,
          1.16,1.46,1.46,0,0,1,.4,1.65A1.52,1.52,0,0,1,400.18,305.79Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M391.81,305.79a1.52,1.52,0,0,1-1.44-1,1.43,1.43,0,0,1,.35-1.61,4.88,4.88,0,0,1,2.54-1.22,0.64,0.64,0,0,
          1,.79.74,4.76,4.76,0,0,1-1.27,2.63A1.35,1.35,0,0,1,391.81,305.79Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M401.74,295.86a1.44,1.44,0,0,1-.53,1.09,5.1,5.1,0,0,1-2.37,1.14,0.67,0.67,0,0,1-.87-0.83,4.77,4.77,0,0,1,
          1.22-2.51,1.44,1.44,0,0,1,1.62-.32A1.53,1.53,0,0,1,401.74,295.86Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M397.49,305.83a1.55,1.55,0,0,1-1.32,1.72,1.46,1.46,0,0,1-1.6-1.14,3.42,3.42,0,0,1,.07-1.17,4.28,4.28,0,0,
          1,.72-1.74,0.7,0.7,0,0,1,1.29,0A5.08,5.08,0,0,1,397.49,305.83Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M397.49,294.14a5.06,5.06,0,0,1-.86,2.51,0.68,0.68,0,0,1-1.24,0,4.66,4.66,0,0,1-.86-2.62,1.47,1.47,0,0,1,
          1.48-1.47,1.49,1.49,0,0,1,1.49,1.47S397.49,294.1,397.49,294.14Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M390.05,301.54a1.49,1.49,0,0,1-1.54-1.33,1.47,1.47,0,0,1,1.13-1.59,2.06,2.06,0,0,1,1,0,16.27,16.27,0,0,1,
          1.75.63,1.48,1.48,0,0,1,.49.38,0.56,0.56,0,0,1,0,.82,1.61,1.61,0,0,1-.25.23A5.15,5.15,0,0,1,390.05,301.54Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M401.78,301.54a5,5,0,0,1-2.38-.87,0.68,0.68,0,0,1,0-1.24,4.65,4.65,0,0,1,2.54-.86,1.47,1.47,0,0,1,1.55,
          1.48A1.54,1.54,0,0,1,401.78,301.54Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
    <path
      d="M396,298.57a1.48,1.48,0,1,1-1.49,1.48A1.46,1.46,0,0,1,396,298.57Z"
      fill="currentColor"
      transform="translate(-388.5 -292.55)"
    />
  </svg>
);

export const AdviceAndSupport = () => (
  <svg
    width="64px"
    height="60px"
    viewBox="0 0 64 60"
    xmlns="https://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-1168.000000, -1681.000000)"
        fillRule="nonzero"
        fill="#FFFFFF"
      >
        <g transform="translate(1000.000000, 1651.000000)">
          <g transform="translate(168.000000, 30.000000)">
            <path
              d="M63.8297872,19.0053191 C63.8297872,13.9289362 61.8529787,9.15574468 58.2638298,
                          5.56595745 C54.6740426,1.97680851 49.9021277,0 44.8257447,0 C39.966383,0 35.3885106,
                          1.81531915 31.8568085,5.11914894 C28.3397872,1.87978723 23.8059574,
                          0.102765957 18.996383,0.102765957 C13.92,0.102765957 9.14744681,2.07957447 5.55765957,
                          5.6693617 C-1.85234043,13.0787234 -1.85170213,25.1368085 5.55765957,
                          32.5474468 L10.3965957,37.3876596 C9.91340426,38.1019149 9.65234043,
                          38.9431915 9.65234043,39.8240426 C9.65234043,40.9876596 10.1048936,
                          42.0817021 10.9282979,42.9038298 C11.7504255,43.7265957 12.8438298,
                          44.1797872 14.0080851,44.1797872 C14.3470213,44.1797872 14.6782979,44.1376596 15,
                          44.0623404 C14.9253191,44.3846809 14.8825532,44.7153191 14.8825532,
                          45.0542553 C14.8825532,46.2178723 15.3357447,47.3112766 16.1591489,
                          48.1334043 C16.9806383,48.9568085 18.0746809,49.41 19.2382979,49.41 C19.5791489,
                          49.41 19.9110638,49.3665957 20.2340426,49.2912766 C19.9040426,50.7102128 20.286383,
                          52.2612766 21.3887234,53.3648936 C22.2114894,54.1870213 23.3048936,
                          54.6402128 24.4691489,54.6402128 C24.8080851,54.6402128 25.1406383,
                          54.5961702 25.4629787,54.5208511 C25.1329787,55.9385106 25.5153191,
                          57.4902128 26.6189362,58.5925532 C27.4410638,59.4153191 28.5344681,
                          59.8685106 29.6993617,59.8685106 C30.6089362,59.8685106 31.4751064,59.5889362 32.202766,
                          59.0738298 C32.9074468,59.5391489 33.7321277,59.7893617 34.5957447,
                          59.7893617 C35.7606383,59.7893617 36.8546809,59.3374468 37.6768085,
                          58.5153191 C38.6278723,57.5629787 39.0465957,56.2768085 38.9317021,
                          55.0314894 C39.4806383,55.277234 40.0825532,55.4048936 40.7023404,55.4048936 C41.8659574,
                          55.4048936 42.9612766,54.9517021 43.7834043,54.1295745 C44.8844681,53.0285106 45.2706383,
                          51.48 44.9444681,50.0642553 C45.2648936,50.1376596 45.5961702,50.1759574 45.9325532,
                          50.1759574 C47.0948936,50.1759574 48.1889362,49.722766 49.0129787,48.9012766 C49.8351064,
                          48.0778723 50.2882979,46.9838298 50.2882979,45.8202128 C50.2882979,45.2068085 50.1631915,
                          44.6138298 49.9244681,44.0693617 C51.1902128,44.1765957 52.4674468,43.7221277 53.3821277,
                          42.8093617 C54.2042553,41.9859574 54.6574468,40.8925532 54.6574468,39.7289362 C54.6574468,
                          38.7268085 54.3197872,37.7770213 53.7012766,37.007234 L58.2651064,32.4440426 C61.8529787,
                          28.8548936 63.8297872,24.0823404 63.8297872,19.0053191 Z M15.966383,41.783617 C15.7621277,
                          41.987234 15.527234,42.1429787 15.2782979,42.2725532 C14.8895745,42.4761702 14.4587234,
                          42.5955319 14.0068085,42.5955319 C13.266383,42.5955319 12.5712766,42.3070213 12.0485106,
                          41.7842553 C11.5251064,41.2614894 11.2365957,40.5651064 11.2365957,39.8246809 C11.2365957,
                          39.372766 11.3559574,38.9419149 11.5595745,38.5519149 C11.6891489,38.303617 11.8442553,
                          38.0693617 12.0485106,37.866383 L12.5814894,37.332766 L16.8434043,33.0702128 C17.3661702,
                          32.5474468 18.0619149,32.2589362 18.8017021,32.2589362 C19.5414894,32.2589362 20.2378723,
                          32.5474468 20.7612766,33.0702128 C21.8419149,34.1508511 21.8419149,35.9087234 20.7625532,
                          36.9887234 L16.4993617,41.2525532 L15.966383,41.783617 Z M21.1965957,47.0138298 C20.9929787,
                          47.2174468 20.7568085,47.3738298 20.507234,47.5040426 C20.1178723,47.7051064 19.6889362,
                          47.8251064 19.236383,47.8251064 C18.4959574,47.8251064 17.8002128,47.537234 17.2780851,
                          47.0138298 C16.403617,46.1393617 16.2497872,44.8270213 16.7891489,43.7834043 C16.9161702,
                          43.536383 17.0706383,43.3002128 17.2780851,43.0940426 L17.8097872,42.5623404 L23.7887234,
                          36.5840426 C24.3114894,36.06 25.0078723,35.7714894 25.7482979,35.7714894 C26.4880851,
                          35.7714894 27.1838298,36.06 27.7065957,36.5840426 C28.23,37.1068085 28.5178723,
                          37.8019149 28.5178723,38.5423404 C28.5178723,39.2821277 28.2293617,39.9785106 27.7065957,
                          40.5019149 L21.7276596,46.4814894 L21.1965957,47.0138298 Z M26.4268085,52.242766 C26.2219149,
                          52.4482979 25.9857447,52.6046809 25.7355319,52.7342553 C25.3461702,
                          52.937234 24.9178723,53.0559574 24.467234,53.0559574 C23.7268085,53.0559574 23.0310638,
                          52.7680851 22.5076596,52.2446809 C21.6344681,51.3721277 21.4806383,50.0597872 22.0187234,
                          49.0155319 C22.1457447,48.7685106 22.3008511,48.5317021 22.5076596,48.3255319 L23.0393617,
                          47.7938298 L26.9565957,43.8778723 L28.2842553,42.5502128 L28.5191489,42.3159574 C29.0419149,
                          41.7925532 29.7382979,41.5046809 30.4774468,41.5046809 C31.2178723,41.5046809 31.913617,
                          41.7925532 32.436383,42.3153191 C33.516383,43.3965957 33.516383,45.1551064 32.4370213,
                          46.2344681 L32.2014894,46.4680851 L30.8738298,47.7957447 L26.9565957,51.7142553 L26.4268085,
                          52.242766 Z M32.1848936,56.9438298 L31.6557447,57.4729787 C31.4508511,57.6778723 31.2140426,
                          57.8348936 30.9644681,57.9651064 C30.5757447,58.1655319 30.1474468,58.2842553 29.6974468,
                          58.2842553 C28.9557447,58.2842553 28.2612766,57.9957447 27.7378723,57.4729787 C26.8646809,
                          56.5997872 26.7095745,55.2893617 27.2476596,54.246383 C27.3746809,53.9980851 27.5297872,
                          53.7606383 27.7378723,53.5544681 L28.2676596,53.0246809 L32.1855319,49.1074468 L32.2697872,
                          49.0231915 C32.7312766,48.5597872 33.3293617,48.2955319 33.9708511,48.2368085 C34.0576596,
                          48.2278723 34.1419149,48.2119149 34.2280851,48.2119149 C34.9685106,48.2119149 35.6648936,
                          48.4997872 36.1889362,49.0225532 C36.7940426,49.6282979 37.0468085,50.4453191 36.9734043,
                          51.2393617 C36.9165957,51.8604255 36.6638298,52.4674468 36.1889362,52.9417021 L36.1034043,
                          53.0265957 L32.1848936,56.9438298 Z M36.5540426,57.3951064 C36.0312766,57.9178723 35.3361702,
                          58.2051064 34.5944681,58.2051064 C34.1853191,58.2051064 33.7914894,58.1093617 33.4314894,
                          57.9408511 L37.0991489,54.2731915 C37.572766,55.296383 37.397234,56.5506383 36.5540426,
                          57.3951064 Z M52.26,41.6885106 C51.7359574,42.2112766 51.0408511,42.4997872 50.3004255,
                          42.4997872 C49.5606383,42.4997872 48.8648936,42.2112766 48.3421277,41.6885106 L37.8095745,
                          31.1565957 C37.5,30.8470213 36.9982979,30.846383 36.6893617,31.1553191 L36.4985106,
                          31.3448936 C36.3491489,31.4929787 36.2661702,31.6946809 36.2661702,31.9059574 C36.2661702,
                          32.1159574 36.3491489,32.3176596 36.497234,32.4670213 L47.8914894,43.86 C48.4142553,
                          44.3834043 48.702766,45.0797872 48.702766,45.8195745 C48.702766,46.56 48.4142553,47.256383 47.8914894,
                          47.7791489 C47.3674468,48.3019149 46.6723404,48.5904255 45.9319149,48.5904255 C45.1921277,
                          48.5904255 44.496383,48.3019149 43.973617,47.7791489 L32.5787234,36.1812766 C32.4293617,
                          36.0325532 32.2282979,35.7446809 32.0176596,35.7446809 L32.016383,35.7446809 C31.806383,
                          35.7446809 31.6040426,36.0338298 31.4559574,36.1838298 L31.266383,36.4768085 C30.9587234,
                          36.786383 30.9593617,37.3385106 31.2676596,37.6468085 L42.6606383,49.0659574 C43.74,
                          50.1446809 43.74,51.9165957 42.6606383,52.997234 C42.1378723,53.5193617 41.4414894,
                          53.8142553 40.7010638,53.8142553 C39.9612766,53.8142553 39.2661702,53.5289362 38.7440426,
                          53.0055319 L38.2876596,52.5497872 C38.8876596,50.9929787 38.5640426,49.1565957 37.3091489,
                          47.9010638 C36.4857447,47.0776596 35.3917021,46.6251064 34.2280851,46.6251064 C34.1987234,
                          46.6251064 34.1687234,46.6289362 34.1393617,46.6302128 C35.2231915,44.9444681 35.0304255,
                          42.6682979 33.5565957,41.1931915 C32.7344681,40.3710638 31.6410638,39.9178723 30.4774468,
                          39.9178723 C30.27,39.9178723 30.0644681,39.9370213 29.8614894,39.9657447 C30.0185106,
                          39.5131915 30.1040426,39.0357447 30.1040426,38.5423404 C30.1040426,37.3787234 29.6502128,
                          36.2846809 28.8280851,35.4625532 C28.0053191,34.6397872 26.9119149,34.1865957 25.7482979,
                          34.1865957 C24.8004255,34.1865957 23.9010638,34.4917021 23.1555319,35.0476596 C23.16,
                          33.9255319 22.7368085,32.8021277 21.882766,31.9480851 C21.0593617,31.1259574 19.9659574,
                          30.672766 18.8023404,30.672766 C17.6393617,30.672766 16.5446809,31.1259574 15.7225532,
                          31.9480851 L11.4606383,36.21 L6.67851064,31.4259574 C-0.114255319,24.6338298 -0.114255319,
                          13.5817021 6.67723404,6.79021277 C9.96829787,3.49978723 14.3425532,1.68765957 18.9951064,
                          1.68765957 C23.3751064,1.68765957 27.5055319,3.29808511 30.7206383,6.23234043 L16.4891489,
                          20.4657447 C14.7906383,22.1642553 14.7848936,24.9223404 16.476383,26.6131915 L17.2308511,
                          27.3670213 C18.0434043,28.1795745 19.1317021,28.6270213 20.2953191,28.6270213 C21.4589362,
                          28.6270213 22.5529787,28.1738298 23.3744681,27.3517021 L32.6087234,18.1187234 L52.26,
                          37.7706383 C52.782766,38.2934043 53.0712766,38.9885106 53.0712766,39.7289362 C53.0719149,
                          40.4687234 52.782766,41.1657447 52.26,41.6885106 Z M52.6729787,35.7931915 L33.2323404,
                          16.3729787 C33.1417021,16.2829787 33.0338298,16.2268085 32.9202128,16.1891489 C32.8397872,
                          16.1623404 32.7568085,16.1406383 32.6719149,16.1406383 C32.4695745,16.1406383 32.2665957,
                          16.2185106 32.1114894,16.3723404 L31.487234,16.997234 L22.253617,26.2308511 C21.7308511,
                          26.753617 21.0357447,27.0421277 20.2953191,27.0421277 C19.5440426,27.0421277 18.8725532,
                          26.7670213 18.3517021,26.2461702 L17.5978723,25.4923404 C16.5242553,24.4193617 16.5306383,
                          22.667234 17.6112766,21.5865957 L31.0819149,8.11276596 L32.5078723,6.68680851 C32.5589362,
                          6.63510638 32.6131915,6.58723404 32.6648936,6.53680851 C35.9374468,3.34340426 40.2446809,
                          1.58425532 44.8257447,1.58425532 C49.4782979,1.58425532 53.8538298,3.39638298 57.1429787,
                          6.68680851 C60.4334043,9.97723404 62.2448936,14.3514894 62.2448936,19.0046809 C62.2448936,
                          23.6578723 60.4334043,28.0321277 57.1429787,31.3225532 L52.6729787,35.7931915 Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const VideoUploadIcon = () => (
  <svg
    width="178px"
    height="116px"
    viewBox="0 0 178 116"
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
  >
    <g
      id="videoUploadIcon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="PersonPage-video-preview"
        transform="translate(-122.000000, -729.000000)"
        fillRule="nonzero"
        fill="#999999"
      >
        <g
          id="Add-Captions-Modal-Copy"
          transform="translate(71.000000, 590.000000)"
        >
          <g
            id="Horizontal-Photo-Container"
            transform="translate(20.000000, 80.000000)"
          >
            <g id="Group-4" transform="translate(27.000000, 59.000000)">
              <g id="noun_539437_cc" transform="translate(4.000000, 0.000000)">
                <g id="Group">
                  <path
                    id="Shape"
                    d="M170.169923,0.645831243 L64.9435093,
                                0.645831243 C60.7081492,0.645831243 57.2483056,
                                4.11892372 57.2483056,8.34381975 L57.2483056,
                                107.623878 C57.2483056,111.868769 60.7081492,
                                115.321866 64.9435093,115.321866 L170.169923,
                                115.321866 C174.387295,115.321866 177.859131,
                                111.866769 177.859131,107.623878 L177.859131,
                                8.34581923 C177.859131,4.1209232 174.387295,
                                0.645831243 170.169923,0.645831243 Z M139.850821,
                                9.89341484 C139.850821,8.62774556 140.890173,
                                7.58801724 142.149388,7.58801724 L149.582755,
                                7.58801724 C150.845968,7.58801724 151.88532,
                                8.62774556 151.88532,9.89341484 L151.88532,
                                17.1035308 C151.88532,18.3751985 150.845968,
                                19.4089284 149.582755,19.4089284 L142.149388,
                                19.4089284 C140.892172,19.4089284 139.850821,
                                18.3751985 139.850821,17.1035308 L139.850821,
                                9.89341484 Z M168.405023,27.32486 C169.670235,
                                27.32486 170.703591,28.3525914 170.703591,
                                29.6242591 L170.703591,86.3554352 C170.703591,
                                87.6211045 169.670235,88.6608328 168.405023,
                                88.6608328 L123.31113,88.6608328 C122.039922,
                                88.6608328 121.00057,87.6211045 121.00057,
                                86.3554352 L121.00057,29.6222597 C121.00057,
                                28.350592 122.039922,27.3228605 123.31113,
                                27.3228605 L168.405023,27.3228605 L168.405023,
                                27.32486 Z M120.974586,9.89341484 C120.974586,
                                8.62774556 122.019935,7.58801724 123.27915,
                                7.58801724 L130.692529,7.58801724 C131.969733,
                                7.58801724 133.003089,8.62774556 133.003089,
                                9.89341484 L133.003089,17.1035308 C133.003089,
                                18.3751985 131.969733,19.4089284 130.692529,
                                19.4089284 L123.27915,19.4089284 C122.021933,
                                19.4089284 120.974586,18.3751985 120.974586,
                                17.1035308 L120.974586,9.89341484 Z M83.2241153,
                                9.89341484 C83.2241153,8.62774556 84.251475,
                                7.58801724 85.5226827,7.58801724 L92.9540508,
                                7.58801724 C94.2192622,7.58801724 95.2586144,
                                8.62774556 95.2586144,9.89341484 L95.2586144,
                                17.1035308 C95.2586144,18.3751985 94.2192622,
                                19.4089284 92.9540508,19.4089284 L85.5226827,
                                19.4089284 C84.251475,19.4089284 83.2241153,
                                18.3751985 83.2241153,17.1035308 L83.2241153,
                                9.89341484 L83.2241153,9.89341484 Z M64.3478806,
                                9.89341484 C64.3478806,8.62774556 65.3872328,
                                7.58801724 66.6524442,7.58801724 L74.0658235,
                                7.58801724 C75.3430275,7.58801724 76.3703871,
                                8.62774556 76.3703871,9.89341484 L76.3703871,
                                17.1035308 C76.3703871,18.3751985 75.3430275,
                                19.4089284 74.0658235,19.4089284 L66.6524442,
                                19.4089284 C65.3872328,19.4089284 64.3478806,
                                18.3751985 64.3478806,17.1035308 L64.3478806,
                                9.89341484 Z M64.3478806,29.6222597 C64.3478806,
                                28.350592 65.3872328,27.3228605 66.6524442,
                                27.3228605 L111.740342,27.3228605 C113.017546,
                                27.3228605 114.050901,28.350592 114.050901,
                                29.6222597 L114.050901,86.3534357 C114.050901,
                                87.619105 113.017546,88.6588333 111.740342,
                                88.6588333 L66.6524442,88.6588333 C65.3872328,
                                88.6588333 64.3478806,87.619105 64.3478806,
                                86.3534357 L64.3478806,29.6222597 Z M76.3683884,
                                106.08428 C76.3683884,107.355948 75.3410287,
                                108.389678 74.0638248,108.389678 L66.6504454,
                                108.389678 C65.385234,108.389678 64.3458818,
                                107.355948 64.3458818,106.08428 L64.3458818,
                                98.8741641 C64.3458818,97.6084948 65.385234,
                                96.5687665 66.6504454,96.5687665 L74.0638248,
                                96.5687665 C75.3410287,96.5687665 76.3683884,
                                97.6084948 76.3683884,98.8741641 L76.3683884,
                                106.08428 Z M95.2566157,106.08428 C95.2566157,
                                107.355948 94.2172635,108.389678 92.9520521,
                                108.389678 L85.5206839,108.389678 C84.2494762,
                                108.389678 83.2221166,107.355948 83.2221166,
                                106.08428 L83.2221166,98.8741641 C83.2221166,
                                97.6084948 84.2494762,96.5687665 85.5206839,
                                96.5687665 L92.9520521,96.5687665 C94.2172635,
                                96.5687665 95.2566157,97.6084948 95.2566157,
                                98.8741641 L95.2566157,106.08428 L95.2566157,
                                106.08428 Z M114.138847,106.08428 C114.138847,
                                107.355948 113.093498,108.389678 111.828287,
                                108.389678 L104.408911,108.389678 C103.137704,
                                108.389678 102.098351,107.355948 102.098351,
                                106.08428 L102.098351,98.8741641 C102.098351,
                                97.6084948 103.139702,96.5687665 104.408911,
                                96.5687665 L111.828287,96.5687665 C113.093498,
                                96.5687665 114.138847,97.6084948 114.138847,
                                98.8741641 L114.138847,106.08428 Z M114.138847,
                                17.1035308 C114.138847,18.3751985 113.093498,
                                19.4089284 111.828287,19.4089284 L104.408911,
                                19.4089284 C103.137704,19.4089284 102.098351,
                                18.3751985 102.098351,17.1035308 L102.098351,
                                9.89341484 C102.098351,8.62774556 103.139702,
                                7.58801724 104.408911,7.58801724 L111.828287,
                                7.58801724 C113.093498,7.58801724 114.138847,
                                8.62774556 114.138847,9.89341484 L114.138847,
                                17.1035308 Z M133.003089,106.08428 C133.003089,
                                107.355948 131.969733,108.389678 130.692529,
                                108.389678 L123.27915,108.389678 C122.021933,
                                108.389678 120.974586,107.355948 120.974586,
                                106.08428 L120.974586,98.8741641 C120.974586,
                                97.6084948 122.019935,96.5687665 123.27915,
                                96.5687665 L130.692529,96.5687665 C131.969733,
                                96.5687665 133.003089,97.6084948 133.003089,
                                98.8741641 L133.003089,106.08428 Z M151.88532,
                                106.08428 C151.88532,107.355948 150.845968,
                                108.389678 149.582755,108.389678 L142.149388,
                                108.389678 C140.892172,108.389678 139.850821,
                                107.355948 139.850821,106.08428 L139.850821,
                                98.8741641 C139.850821,97.6084948 140.890173,
                                96.5687665 142.149388,96.5687665 L149.582755,
                                96.5687665 C150.845968,96.5687665 151.88532,
                                97.6084948 151.88532,98.8741641 L151.88532,
                                106.08428 Z M170.767551,106.08428 C170.767551,
                                107.355948 169.734195,108.389678 168.462987,
                                108.389678 L161.037615,108.389678 C159.766408,
                                108.389678 158.727056,107.355948 158.727056,
                                106.08428 L158.727056,98.8741641 C158.727056,
                                97.6084948 159.766408,96.5687665 161.037615,
                                96.5687665 L168.462987,96.5687665 C169.734195,
                                96.5687665 170.767551,97.6084948 170.767551,
                                98.8741641 L170.767551,106.08428 Z M170.767551,
                                17.1035308 C170.767551,18.3751985 169.734195,
                                19.4089284 168.462987,19.4089284 L161.037615,
                                19.4089284 C159.766408,19.4089284 158.727056,
                                18.3751985 158.727056,17.1035308 L158.727056,
                                9.89341484 C158.727056,8.62774556 159.766408,
                                7.58801724 161.037615,7.58801724 L168.462987,
                                7.58801724 C169.734195,7.58801724 170.767551,
                                8.62774556 170.767551,9.89341484 L170.767551,
                                17.1035308 Z"
                  />
                  <path
                    id="Shape"
                    d="M113.085503,0.645831243 L7.85908913,
                                0.645831243 C3.62372897,0.645831243 0.16388543,
                                4.11892372 0.16388543,8.34381975 L0.16388543,
                                107.623878 C0.16388543,111.868769 3.62372897,
                                115.321866 7.85908913,115.321866 L113.085503,
                                115.321866 C117.302875,115.321866 120.774711,
                                111.866769 120.774711,107.623878 L120.774711,
                                8.34581923 C120.774711,4.1209232 117.302875,
                                0.645831243 113.085503,0.645831243 Z M82.7664006,
                                9.89341484 C82.7664006,8.62774556 83.8057528,
                                7.58801724 85.064968,7.58801724 L92.4983349,
                                7.58801724 C93.7615475,7.58801724 94.8008997,
                                8.62774556 94.8008997,9.89341484 L94.8008997,
                                17.1035308 C94.8008997,18.3751985 93.7615475,
                                19.4089284 92.4983349,19.4089284 L85.064968,
                                19.4089284 C83.8077516,19.4089284 82.7664006,
                                18.3751985 82.7664006,17.1035308 L82.7664006,
                                9.89341484 Z M111.320603,27.32486 C112.585815,
                                27.32486 113.619171,28.3525914 113.619171,
                                29.6242591 L113.619171,86.3554352 C113.619171,
                                87.6211045 112.585815,88.6608328 111.320603,
                                88.6608328 L66.2267095,88.6608328 C64.9555019,
                                88.6608328 63.9161497,87.6211045 63.9161497,
                                86.3554352 L63.9161497,29.6222597 C63.9161497,
                                28.350592 64.9555019,27.3228605 66.2267095,
                                27.3228605 L111.320603,27.3228605 L111.320603,
                                27.32486 Z M63.8901659,9.89341484 C63.8901659,
                                8.62774556 64.9355143,7.58801724 66.1947295,
                                7.58801724 L73.6081088,7.58801724 C74.8853128,
                                7.58801724 75.9186687,8.62774556 75.9186687,
                                9.89341484 L75.9186687,17.1035308 C75.9186687,
                                18.3751985 74.8853128,19.4089284 73.6081088,
                                19.4089284 L66.1947295,19.4089284 C64.9375131,
                                19.4089284 63.8901659,18.3751985 63.8901659,
                                17.1035308 L63.8901659,9.89341484 Z M26.1376964,
                                9.89341484 C26.1376964,8.62774556 27.165056,
                                7.58801724 28.4362637,7.58801724 L35.8676319,
                                7.58801724 C37.1328433,7.58801724 38.1721955,
                                8.62774556 38.1721955,9.89341484 L38.1721955,
                                17.1035308 C38.1721955,18.3751985 37.1328433,
                                19.4089284 35.8676319,19.4089284 L28.4362637,
                                19.4089284 C27.165056,19.4089284 26.1376964,
                                18.3751985 26.1376964,17.1035308 L26.1376964,
                                9.89341484 Z M7.26346038,9.89341484 C7.26346038,
                                8.62774556 8.30281257,7.58801724 9.56802398,
                                7.58801724 L16.9814033,7.58801724 C18.2586073,
                                7.58801724 19.2859669,8.62774556 19.2859669,
                                9.89341484 L19.2859669,17.1035308 C19.2859669,
                                18.3751985 18.2586073,19.4089284 16.9814033,
                                19.4089284 L9.56802398,19.4089284 C8.30281257,
                                19.4089284 7.26346038,18.3751985 7.26346038,
                                17.1035308 L7.26346038,9.89341484 Z M7.26346038,
                                29.6222597 C7.26346038,28.350592 8.30281257,
                                27.3228605 9.56802398,27.3228605 L54.6559214,
                                27.3228605 C55.9331254,27.3228605 56.9664813,
                                28.350592 56.9664813,29.6222597 L56.9664813,
                                86.3534357 C56.9664813,87.619105 55.9331254,
                                88.6588333 54.6559214,88.6588333 L9.56802398,
                                88.6588333 C8.30281257,88.6588333 7.26346038,
                                87.619105 7.26346038,86.3534357 L7.26346038,
                                29.6222597 Z M19.2839682,106.08428 C19.2839682,
                                107.355948 18.2566085,108.389678 16.9794046,
                                108.389678 L9.56602523,108.389678 C8.30081381,
                                108.389678 7.26146163,107.355948 7.26146163,
                                106.08428 L7.26146163,98.8741641 C7.26146163,
                                97.6084948 8.30081381,96.5687665 9.56602523,
                                96.5687665 L16.9794046,96.5687665 C18.2566085,
                                96.5687665 19.2839682,97.6084948 19.2839682,
                                98.8741641 L19.2839682,106.08428 Z M38.1721955,
                                106.08428 C38.1721955,107.355948 37.1328433,
                                108.389678 35.8676319,108.389678 L28.4362637,
                                108.389678 C27.165056,108.389678 26.1376964,
                                107.355948 26.1376964,106.08428 L26.1376964,
                                98.8741641 C26.1376964,97.6084948 27.165056,
                                96.5687665 28.4362637,96.5687665 L35.8676319,
                                96.5687665 C37.1328433,96.5687665 38.1721955,
                                97.6084948 38.1721955,98.8741641 L38.1721955,
                                106.08428 Z M57.0544265,106.08428 C57.0544265,
                                107.355948 56.009078,108.389678 54.7438666,
                                108.389678 L47.324491,108.389678 C46.0532833,
                                108.389678 45.0139311,107.355948 45.0139311,
                                106.08428 L45.0139311,98.8741641 C45.0139311,
                                97.6084948 46.0552821,96.5687665 47.324491,
                                96.5687665 L54.7438666,96.5687665 C56.009078,
                                96.5687665 57.0544265,97.6084948 57.0544265,
                                98.8741641 L57.0544265,106.08428 Z M57.0544265,
                                17.1035308 C57.0544265,18.3751985 56.009078,
                                19.4089284 54.7438666,19.4089284 L47.324491,
                                19.4089284 C46.0532833,19.4089284 45.0139311,
                                18.3751985 45.0139311,17.1035308 L45.0139311,
                                9.89341484 C45.0139311,8.62774556 46.0552821,
                                7.58801724 47.324491,7.58801724 L54.7438666,
                                7.58801724 C56.009078,7.58801724 57.0544265,
                                8.62774556 57.0544265,9.89341484 L57.0544265,
                                17.1035308 Z M75.9186687,106.08428 C75.9186687,
                                107.355948 74.8853128,108.389678 73.6081088,
                                108.389678 L66.1947295,108.389678 C64.9375131,
                                108.389678 63.8901659,107.355948 63.8901659,
                                106.08428 L63.8901659,98.8741641 C63.8901659,
                                97.6084948 64.9355143,96.5687665 66.1947295,
                                96.5687665 L73.6081088,96.5687665 C74.8853128,
                                96.5687665 75.9186687,97.6084948 75.9186687,
                                98.8741641 L75.9186687,106.08428 Z M94.798901,
                                106.08428 C94.798901,107.355948 93.7595488,
                                108.389678 92.4963361,108.389678 L85.0629692,
                                108.389678 C83.8057528,108.389678 82.7644019,
                                107.355948 82.7644019,106.08428 L82.7644019,
                                98.8741641 C82.7644019,97.6084948 83.8037541,
                                96.5687665 85.0629692,96.5687665 L92.4963361,
                                96.5687665 C93.7595488,96.5687665 94.798901,
                                97.6084948 94.798901,98.8741641 L94.798901,
                                106.08428 Z M113.681132,106.08428 C113.681132,
                                107.355948 112.647776,108.389678 111.376568,
                                108.389678 L103.951196,108.389678 C102.679989,
                                108.389678 101.640637,107.355948 101.640637,
                                106.08428 L101.640637,98.8741641 C101.640637,
                                97.6084948 102.679989,96.5687665 103.951196,
                                96.5687665 L111.376568,96.5687665 C112.647776,
                                96.5687665 113.681132,97.6084948 113.681132,
                                98.8741641 L113.681132,106.08428 L113.681132,
                                106.08428 Z M113.681132,17.1035308 C113.681132,
                                18.3751985 112.647776,19.4089284 111.376568,
                                19.4089284 L103.951196,19.4089284 C102.679989,
                                19.4089284 101.640637,18.3751985 101.640637,
                                17.1035308 L101.640637,9.89341484 C101.640637,
                                8.62774556 102.679989,7.58801724 103.951196,
                                7.58801724 L111.376568,7.58801724 C112.647776,
                                7.58801724 113.681132,8.62774556 113.681132,
                                9.89341484 L113.681132,17.1035308 L113.681132,
                                17.1035308 Z"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const LegacycomIcon = () => (
  <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 1100.9 200.9">
    <g fill="#999">
      <path
        d="M668.1 126c1.7-1.7 3.7-2.5 6.1-2.5 2.4 0 4.4.8 6.1 2.5 1.7 1.7,
          2.5 3.7 2.5 6.1 0 2.4-.8 4.4-2.5 6-1.7 1.6-3.7 2.4-6.1 2.4-2.4,
          0-4.4-.8-6.1-2.4-1.7-1.6-2.5-3.6-2.5-6-.1-2.4.8-4.4 2.5-6.1zM773.9,
          137.7c-5.4 1.8-11.1 2.7-17.4 2.7-7.3,
          0-14.1-1.3-20.4-3.9-6.2-2.6-11.6-6.3-16-10.9-4.5-4.6-8-10.1-10.6-16.3-2.6-6.2-3.8-12.9-3.8-20.1,
          0-7.2 1.2-13.9 3.7-20.2 2.5-6.3 6-11.8 10.5-16.5 4.5-4.7 9.9-8.4 16.2-11.1 6.2-2.7,
          13-4.1 20.4-4.1 6.2 0 12 .9 17.4 2.7 5.4 1.8 10.3 4.2 14.7 7.1l-4.1,
          6c-4-2.6-8.3-4.7-12.8-6.4-4.6-1.7-9.6-2.5-15.2-2.5-6.4 0-12.2 1.2-17.5,
          3.5-5.3 2.3-9.8 5.4-13.5 9.4-3.8 3.9-6.7 8.6-8.8 14-2.1 5.4-3.1 11.3-3.1,
          17.5 0 6.2 1 12.1 3.1 17.6 2.1 5.5 5 10.3 8.8 14.4 3.8 4.1 8.3 7.3 13.5,
          9.6 5.3 2.3 11.1 3.5 17.5 3.5 5.6 0 10.7-.8 15.2-2.5 4.6-1.7 8.8-3.8,
          12.8-6.4l4.1 6c-4.5 2.7-9.4 5.1-14.7 6.9zM894.1 108.8c-2.5 6.4-5.9,
          11.9-10.2 16.5-4.3 4.6-9.5 8.3-15.5 11-6 2.7-12.5 4.1-19.5,
          4.1s-13.5-1.3-19.4-3.9c-5.9-2.6-11-6.3-15.2-10.9-4.2-4.6-7.6-10.1-9.9-16.4-2.4-6.3-3.6-13-3.6-20.2,
          0-7.2 1.2-13.9 3.7-20.3 2.5-6.3 5.9-11.8 10.2-16.5 4.3-4.7,
          9.4-8.4 15.3-11 5.9-2.6 12.4-3.9 19.4-3.9 7 0 13.5 1.3 19.4,
          3.9 5.9 2.6 11 6.2 15.3 10.8 4.3 4.6 7.7 10 10.1 16.3 2.4 6.3,
          3.6 13 3.6 20.2.1 7.2-1.2 14-3.7,
          20.3zm-7-37.6c-1.9-5.4-4.7-10.1-8.3-14.1-3.6-4-7.9-7.1-12.9-9.5-5-2.3-10.6-3.5-16.6-3.5-6.1,
          0-11.6 1.2-16.5 3.5-5 2.3-9.2 5.5-12.8 9.5-3.6 4-6.3 8.7-8.3,
          14.1-1.9 5.4-2.9 11.3-2.9 17.5 0 6.2 1 12.1 2.9 17.6 1.9 5.5 4.6 10.3,
          8.1 14.2 3.5 4 7.8 7.2 12.8 9.5 5 2.3 10.6 3.5 16.7 3.5s11.6-1.2,
          16.5-3.5c5-2.3 9.2-5.5 12.8-9.6 3.6-4.1 6.4-8.8 8.4-14.3 2-5.4,
          3-11.3 3-17.5 0-6.1-1-12-2.9-17.4zM1057.7 71.7c0-18.2-7.8-27.3-23.5-27.3-7.2,
          0-14.1 2.1-20.6 6.2-6.5 4.2-12.4 9.7-17.5 16.5v71.4h-7.7V71.7c0-18.2-7.8-27.3-23.5-27.3-7.3 0-14.2,
          2.1-20.5 6.2-6.3 4.2-12.2 9.3-17.6 15.3v72.6h-7.7V39.1h7.4v18.7c2.2-2.5,
          4.8-5.1 7.7-7.5 2.9-2.5 6-4.7 9.2-6.6 3.3-1.9 6.8-3.5 10.7-4.7,
          3.8-1.2 7.8-1.8 12-1.8 6.7 0 12.6 1.8 17.7 5.5s8.6 9.4 10.3 17c4.8-6.1,
          10.8-11.4 18-15.8 7.2-4.5 14.9-6.7 23.2-6.7 4 0 7.8.6 11.4 1.9 3.6 1.3,
          6.8 3.3 9.6 6.1s5 6.3 6.6 10.5c1.6 4.2 2.4 9.3 2.4 15.2v67.6h-7.7V71.7z"
      />
    </g>
    <g fill="#069">
      <path
        d="M0 144.1c8.8-.9 14.5-2.5 17.1-4.7 2.6-2.2 3.9-7.8,
          3.9-16.8V26c0-8.5-1.3-14.1-3.9-16.7C14.6 6.7 8.9 5.1 0,
          4.5V0h67.6v4.5c-8.8.5-14.7 1.9-17.7 4.3s-4.5 7.6-4.5,
          15.6v105.1c0 2.7.5 4.7 1.3 6.3.9 1.5 2.9 2.5 5.9 2.9,
          1.8.2 3.7.4 5.7.5 2 .1 5.7.1 11.2.1 21.3 0 26.5-1.8,
          34-5.3s14.8-12.5 21.8-26.9h6.1l-11.7 41.5H0v-4.5zM218.2,
          50.2c8.3 7.6 12.4 18.4 12.4 32.3h-74.3c.8 18.1 4.9 31.2,
          12.3 39.5 7.4 8.2 16.2 12.4 26.3 12.4 8.2 0 15.1-2.1,
          20.7-6.4 5.6-4.3 10.8-10.3 15.6-18.2l4.1 1.4c-3.2 9.9-9.2,
          19.1-18 27.5-8.8 8.4-19.5 12.6-32.2 12.6-14.7,
          0-26-5.5-34-16.6-8-11.1-12-23.8-12-38.3 0-15.7 4.6-29.2,
          13.9-40.6 9.3-11.4 21.4-17.1 36.3-17.1 11 .1 20.6 3.9 28.9,
          11.5zm-56.1 9c-2.5 4.2-4.3 9.5-5.4,
          15.9h49.4c-.9-7.8-2.3-13.6-4.4-17.4-3.8-6.9-10.2-10.3-19.2-10.3-8.9-.1-15.7 3.9-20.4,
          11.8zM252.9 96.7c-3.9-6-5.9-12.8-5.9-20.2 0-9.1 3.6-17.8 10.9-26,
          7.3-8.2 17.5-12.3 30.8-12.3 5.7 0 12 1.3 18.8 4 6.9 2.7 13.5 4,
          19.8 4 1.6 0 4.1-.1 7.4-.2 3.3-.1 5.7-.2 7.2-.2h1.4v9.5h-20.2c1.4,
          3.3 2.5 6.1 3.3 8.5 1.3 4.5 2 8.8 2 12.9 0 8.9-3.7 17.1-11.1,
          24.5-7.4 7.5-17.3 11.2-29.8 11.2-1.9 0-5.5-.3-10.5-1-2.3 0-5.3,
          1.9-9 5.7-3.7 3.8-5.6 6.9-5.6 9.4s2.7 4.3 8.2 5.5c3.6.8 7.6 1.2,
          12 1.2 20.1 0 33.7 1.1 40.9 3.4 11.8 3.7 17.7 11.5 17.7 23.6 0,
          12.3-6.9 22.2-20.6 29.5-13.8 7.3-27.7 11-41.7 11-12.8,
          0-22.9-2.6-30.4-7.8-7.5-5.2-11.2-10.6-11.2-16.3 0-2.8 1-5.5 3-8.2,
          2-2.7 5.9-6.7 11.7-12l7.7-6.9 1.4-1.4c-3.6-1.4-6.2-2.8-8-4.1-3.1-2.4-4.7-5.2-4.7-8.3,
          0-2.9 1.4-6.1 4-9.5 2.7-3.5 8.4-9.1 17.3-16.9-7.3-2.4-12.8-6.6-16.8-12.6zm12.4,
          87c7.4 2.5 15.8 3.7 25.3 3.7 12.9 0 23.5-2.2 31.6-6.7 8.1-4.5,
          12.2-10 12.2-16.6 0-5.2-3.3-8.7-9.8-10.4-4.1-1-11.8-1.6-23.1-1.8-2.9-.1-5.9-.2-9.1-.3-3.2-.1-6.1-.3-8.8-.4-1.7-.1-4.5-.4-8.3-.9-3.8-.5-6.7-1-8.6-1.4-.9,
          0-3.2 2.5-6.8 7.4-3.7 5-5.6 9.6-5.6 13.8 0 6.6 3.7 11.1 11,
          13.6zm37.2-80.3c4.7-3.7 7-10.3 7-19.5 0-7.4-1.9-15.7-5.7-25C300,
          49.6 293.7 45 284.9 45c-7.6 0-12.9 3.6-15.8 10.9-1.5 3.8-2.2,
          8.5-2.2 14.2 0 9.5 2.3 18.1 6.9 25.6 4.6 7.6 10.6 11.3 17.9,
          11.3 4.3-.1 7.9-1.3 10.8-3.6zM366.3 96.9c7.2-4.7 21.5-11,
          42.9-19.1v-9.9c0-7.9-.8-13.5-2.3-16.6-2.7-5.2-8.1-7.8-16.5-7.8-4,
          0-7.8 1-11.4 3-3.6 2.1-5.4 5-5.4 8.7 0 .9.2 2.5.6 4.7.4 2.2.6,
          3.6.6 4.3 0 4.4-1.4 7.4-4.3 9.1-1.6 1-3.6 1.5-5.9 1.5-3.5,
          0-6.2-1.2-8.1-3.5-1.9-2.3-2.8-4.9-2.8-7.7 0-5.5 3.4-11.2 10.1-17.1,
          6.7-6 16.6-9 29.7-9 15.1 0 25.4 4.9 30.8 14.7 2.9 5.4 4.3 13.2 4.3,
          23.5v46.9c0 4.5.3 7.6.9 9.4 1 3 3.1 4.6 6.3 4.6 1.8 0 3.3-.3,
          4.4-.8 1.2-.5 3.2-1.9 6.1-4v6.1c-2.5 3-5.2 5.5-8.1 7.5-4.4,
          3-8.8 4.4-13.3 4.4-5.3 0-9.1-1.7-11.5-5.2-2.4-3.4-3.7-7.5-3.9-12.3-5.9 5.2-11,
          9-15.2 11.5-7.1 4.2-13.8 6.3-20.2 6.3-6.7 0-12.5-2.4-17.4-7.1-4.9-4.7-7.4-10.7-7.4-18 .1-11.1,
          5.7-20.5 17-28.1zm42.9-13.2c-9 3-16.4 6.2-22.2 9.8-11.2 6.9-16.9,
          14.8-16.9 23.6 0 7.1 2.3 12.3 7 15.7 3 2.2 6.4 3.3 10.2 3.3 5.1 0,
          10.1-1.4 14.8-4.3 4.7-2.9 7.1-6.6 7.1-11V83.7zM531.7 45.7c7.1 5,
          10.6 10.5 10.6 16.5 0 2.6-.9 4.9-2.7 7.2-1.8 2.2-4.6 3.3-8.3,
          3.3-2.7 0-5.1-.9-7.2-2.8-2.1-1.9-3.6-4.6-4.5-8.2l-1.4-5.6c-1-4.1-2.8-7.1-5.3-8.8-2.6-1.6-6-2.4-10.2-2.4-8.9 0-16.4,
          3.9-22.5 11.6-6.1 7.8-9.2 18.1-9.2 31 0 11.8 3.4 22.4 10.1,
          31.7 6.7 9.4 15.9 14.1 27.3 14.1 8.1 0 15.3-2.7 21.6-8 3.6-3,
          7.6-7.9 12.2-14.5l3.3 2c-4.4 9.4-9.1 16.8-14 22.3-9.4 10.5-20.4,
          15.7-32.8 15.7-12.2 0-22.9-4.8-32.3-14.4-9.4-9.6-14-22.6-14-39.1,
          0-16.1 5.1-30 15.3-41.6C478 44 490.9 38.2 506.5 38.2c9.7 0 18.1 2.5,
          25.2 7.5zM546.6 41H596v3.3c-3.9.1-6.8.5-8.7 1.1-3.6 1-5.4 3.1-5.4,
          6.1 0 1.1.2 2.3.6 3.4.4 1.2 1.1 2.9 2.1 5.2l27.1 58.6 22.3-59c.2-.6.6-2.1,
          1.1-4.3.5-2.2.8-3.7.8-4.6 0-2.1-.7-3.6-2.1-4.5-1.4-1-3.2-1.5-5.4-1.7l-3.6-.2V41H657v3.3c-3.2.4-5.6 1.5-7.2 3.4-1.6 1.8-3,
          4.4-4.2 7.7L608.7 153c-6.4 16.9-12.5 29.1-18.4 36.6-5.9 7.6-13.3,
          11.3-22.2 11.3-4.4 0-8.5-1.1-12.3-3.3-3.8-2.2-5.7-5.7-5.7-10.4,
          0-3.1 1.1-5.7 3.4-7.7s5.1-3 8.6-3c2 0 5 .7 9 2.2 4 1.5 6.8 2.2 8.5,
          2.2 4.3 0 8.9-5.3 13.6-15.9 4.8-10.6 7.2-17.6 7.2-21,
          0-.7-.1-1.5-.3-2.5-.2-1-.5-1.9-.8-2.7l-36.9-79.7c-2.6-5.8-5-9.6-7-11.4-2-1.8-4.9-3-8.8-3.6V41z"
      />
    </g>
    <path
      fill="#999"
      d="M1075 26.2c0-2.3.6-4.4 1.7-6.5 1.1-2 2.7-3.6 4.7-4.8 2-1.2 4.2-1.7,
        6.5-1.7s4.4.6 6.5 1.7c2 1.1 3.6 2.7 4.7 4.7 1.2 2 1.7 4.2 1.7 6.5s-.6,
        4.4-1.7 6.4-2.7 3.6-4.7 4.8c-2 1.2-4.2 1.8-6.6 1.8-2.4,
        0-4.6-.6-6.6-1.8-2-1.2-3.6-2.8-4.7-4.8-1-1.9-1.5-4-1.5-6.3zm1.6,
        0c0 2 .5 3.9 1.5 5.7 1 1.7 2.4 3.1 4.1 4.1 1.7 1 3.6 1.5 5.7,
        1.5s3.9-.5 5.7-1.5c1.7-1 3.1-2.4 4.1-4.1 1-1.7 1.5-3.6 1.5-5.7,
        0-2-.5-3.9-1.5-5.6-1-1.7-2.4-3.1-4.1-4.2-1.8-1.1-3.7-1.6-5.8-1.6-2,
        0-3.9.5-5.7 1.5-1.8 1-3.1 2.4-4.2 4.2-.8 1.8-1.3 3.7-1.3,
        5.7zm15.9-3.2c0 .9-.2 1.7-.7 2.4-.4.7-1.1 1.2-1.9 1.6l4.1,
        6.8h-2.1l-3.6-6.2h-2.9v6.2h-1.7V18.7h3.6c1.6 0 2.9.4 3.8 1.1,
        1 .6 1.4 1.7 1.4 3.2zm-7 3.2h1.9c1 0 1.9-.3 2.5-.8.6-.5.9-1.3.9-2.3,
        0-2-1.1-3-3.4-3h-1.9v6.1z"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    version="1.1"
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="-596 381.8 30.2 30.2"
    enableBackground="new -596 381.8 30.2 30.2"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill="#FFFFFF"
        d="M-575.8,385.2c-4.6-4.6-12.1-4.6-16.7,0c-4.6,4.6-4.6,12.1,0,16.7c4.1,
          4.1,10.5,4.5,15.1,1.3 c0.1,0.5,0.3,0.9,0.7,1.3l6.7,6.7c1,1,2.6,1,3.5,
          0c1-1,1-2.6,0-3.5l-6.7-6.7c-0.4-0.4-0.8-0.6-1.3-0.7 C-571.3,395.7-571.7,
          389.3-575.8,385.2z M-577.9,399.8c-3.4,3.4-9,3.4-12.5,0c-3.4-3.4-3.4-9,
          0-12.5c3.4-3.4,9-3.4,12.5,0 C-574.5,390.8-574.5,396.4-577.9,399.8z"
      />
    </g>
  </svg>
);

export const GalleryIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      d="M26 35.188L18.75 22.5 8.75 40H42.5l-10-13.75-6.5 8.938zM0 1.99C0 .89.89 0 1.99 0h46.02C49.108 0 50 .89 50 1.99v46.02c0 1.099-.89 1.99-1.99 1.99H1.99C.892 50 0 49.11 0 48.01V1.99zM30 20a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const GalleryAddIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 14 14"
    xmlns="https://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M7-2.9L16.9 7 7 16.9-2.9 7z" />
      <path
        d="M11.95 11.95a7 7 0 1 1-9.9-9.9 7 7 0 0 1 9.9 9.9zm-4.2-8.485a.75.75 0 1 0-1.5 0V6.25H3.464a.75.75 0 1 0 0 1.5H6.25v2.786a.75.75 0 1 0 1.5 0V7.75h2.786a.75.75 0 1 0 0-1.5H7.75V3.465z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const EmailSignupIcon = () => (
  <svg width="142" height="80" viewBox="0 0 142 80">
    <g fill="#FFF" fillRule="evenodd">
      <path d="M63.528 0h-.318c-4.124 0-7.479 3.387-7.479 7.55V8.93c-9.961 3.262-17.184 12.715-17.184 23.845v21.238c0 1.042-.84 1.89-1.871 1.89h-.096c-4.18 0-7.58 3.433-7.58 7.653v.115c0 4.22 3.4 7.653 7.58 7.653h17.898c.39 4.692 4.291 8.675 9.038 8.675h.145c4.747 0 8.647-3.983 9.038-8.675h18.413c3.963 0 6.625-3.075 6.625-7.653v-.115c0-4.578-2.662-7.653-6.625-7.653h-.096a1.882 1.882 0 0 1-1.87-1.89V33.017c0-11.528-7.678-21.273-18.14-24.316V7.55c0-4.163-3.355-7.55-7.478-7.55zM59.55 7.55c0-2.037 1.642-3.695 3.66-3.695h.317c2.018 0 3.66 1.658 3.66 3.695v.362a24.86 24.86 0 0 0-3.107-.201h-.706c-1.3 0-2.577.102-3.824.298v-.46zm4.11 68.595h-.145c-2.64 0-4.83-2.258-5.202-4.82h10.549c-.371 2.562-2.562 4.82-5.202 4.82zm27.395-16.386h.057c2.533 0 2.807 2.655 2.807 3.798v.115c0 1.142-.274 3.798-2.807 3.798H36.58c-2.073 0-3.761-1.704-3.761-3.798v-.115c0-2.094 1.688-3.798 3.761-3.798h54.475zm-5.728-26.742v20.997c0 .664.117 1.297.322 1.89H42.043a5.756 5.756 0 0 0 .323-1.89V32.776c0-11.696 9.424-21.21 21.008-21.21h.706c11.716 0 21.247 9.622 21.247 21.45zM102.95 12.986c-1.052 0-1.945.933-1.95 1.971v23.659c0 1.032.929 1.971 1.95 1.971h37.04c1.022 0 1.95-.94 1.95-1.971V14.957c0-1.032-.928-1.971-1.95-1.971h-37.04zm5.94 3.943h25.16l-12.58 9.365-12.58-9.365zm-3.99 1.91l15.413 11.49a1.932 1.932 0 0 0 2.315 0l15.413-11.49v17.805H104.9V18.84zM1.402 29.278c-.756 0-1.398.68-1.402 1.435v17.223c0 .751.668 1.435 1.402 1.435h26.63c.733 0 1.401-.684 1.401-1.435V30.713c0-.751-.668-1.435-1.402-1.435H1.401zm4.27 2.87h18.089l-9.044 6.818-9.045-6.817zM2.803 33.54l11.081 8.365c.495.373 1.17.373 1.665 0l11.08-8.365v12.962H2.804V33.539z" />
      <path d="M91.99 2.19c-.534 0-.988.467-.99.985v11.807c0 .515.471.984.99.984h18.796c.518 0 .989-.469.989-.984V3.175c0-.515-.471-.984-.99-.984H91.99zm3.013 1.969h12.768l-6.384 4.673-6.384-4.673zm-2.024.953l7.821 5.734a.994.994 0 0 0 1.175 0l7.821-5.734v8.886H92.98V5.112z" />
    </g>
  </svg>
);

export const EmailSignupSuccessIcon = () => (
  <svg width="40" height="42" viewBox="0 0 40 40">
    <g fill="none" fillRule="evenodd">
      <circle cx="20" cy="20" r="20" fill="#FFF" />
      <path
        stroke="#46BE6F"
        strokeWidth="3"
        d="M10 21.182l6.364 6.363L30.909 13"
      />
    </g>
  </svg>
);

export const InfoIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
  >
    <g fill="none" fillRule="evenodd" transform="translate(1.326 1)">
      <circle cx="7.5" cy="7.5" r="7.5" stroke="#979797" />
      <text
        fill="#999"
        fontFamily="OpenSans-Bold, Open Sans, sans-serif"
        fontSize="10"
        fontWeight="bold"
      >
        <tspan x="5.415" y="11">
          ?
        </tspan>
      </text>
    </g>
  </svg>
);

export const VideoPlayIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="75"
    height="75"
    viewBox="0 0 75 75"
  >
    <g fill="none" fillRule="evenodd">
      <circle cx="37.5" cy="37.5" r="37.5" fill="#E1E1E1" fillOpacity=".75" />
      <path
        fill="#FFF"
        d="M53.311 37.656c1.485.742 1.494 1.941 0 2.688L28.69 52.656C27.204 53.398 26 52.653 26 51V27c0-1.657 1.195-2.403 2.689-1.656L53.31 37.656z"
      />
    </g>
  </svg>
);

export const CondolenceQuotesIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="47"
    height="43"
    viewBox="0 0 47 43"
  >
    <g fill="none" fillRule="evenodd" transform="translate(.372)">
      <ellipse cx="23" cy="21.5" fill="#F5F5F5" rx="23" ry="21.5" />
      <path
        fill="#828892"
        d="M33.316 11.138v1.196c-1.81.618-3.23 1.591-4.257 2.917-1.027 1.327-1.54 2.706-1.54 4.139 0 .309.052.537.156.683.07.098.148.147.235.147s.218-.057.392-.171c.557-.375 1.262-.562 2.115-.562.993 0 1.872.379 2.638 1.136.766.756 1.15 1.656 1.15 2.697 0 1.09-.44 2.051-1.32 2.881-.879.83-1.945 1.245-3.199 1.245-1.463 0-2.725-.561-3.787-1.684-1.062-1.123-1.593-2.629-1.593-4.517 0-2.197.722-4.167 2.168-5.908 1.445-1.742 3.726-3.141 6.842-4.2zm-12.562 0v1.196c-1.81.618-3.23 1.591-4.257 2.917-1.028 1.327-1.541 2.706-1.541 4.139 0 .309.052.537.157.683.07.098.148.147.235.147s.217-.057.391-.171c.558-.375 1.263-.562 2.116-.562.992 0 1.872.379 2.638 1.136.766.756 1.149 1.656 1.149 2.697 0 1.09-.44 2.051-1.319 2.881-.88.83-1.946 1.245-3.2 1.245-1.462 0-2.724-.561-3.786-1.684-1.063-1.123-1.594-2.629-1.594-4.517 0-2.197.723-4.167 2.168-5.908 1.445-1.742 3.726-3.141 6.843-4.2z"
      />
    </g>
  </svg>
);

export const ThankYouEmailIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="56"
    height="40"
    viewBox="0 0 56 40"
  >
    <path
      fill="#FFF"
      fillRule="evenodd"
      d="M51.8 12.8l-5.811 5.934c-1.89 1.932-3.781 3.863-5.673 5.793L28.832 12.788a6.025 6.025 0 0 1
          0-8.486c1.12-1.143 2.599-1.772 4.163-1.772 1.565 0 3.044.629 4.163 1.771l2.28
          2.336c.225.232.547.365.884.365.337 0 .659-.133.881-.363l2.27-2.325c1.12-1.142 2.598-1.771
          4.164-1.771 1.565 0 3.044.629 4.164 1.77a6.022 6.022 0 0 1 0 8.487zM2.61 37.322V16.048l17.44
          13.16c.463.35 1.085.35 1.547 0l11.378-8.585 6.063 6.199v10.5H2.61zm24.633-22.558l3.868 3.954-10.287
          7.75L5.289 14.764h21.954zM53.55 2.514C51.97.902 49.869.014 47.637.014c-2.233 0-4.333.888-5.915
          2.502l-1.395 1.43-1.432-1.457c-1.71-1.607-3.972-2.56-5.91-2.484a8.225 8.225 0 0 0-5.903
          2.499c-2.536 2.587-3.105 6.433-1.707 9.583H1.305c-.68 0-1.301.64-1.305 1.343v25.232C0
          39.337.646 40 1.305 40h39.038c.658 0 1.305-.663 1.305-1.339V26.756c1.94-1.98 3.879-3.961
          5.817-5.942l6.086-6.215c3.265-3.332 3.265-8.753 0-12.084z"
    />
  </svg>
);

export const CloseXIcon = ({primaryFill, size}) => {
  let path =
    'M13.22,12l8.84,8.8a.85.85,0,0,1,0,1.21l-.26.25a.88.88,0,0,1-1.22,0l-8.72-8.7L3.06,22.24a.86.86,0,0,1-1.22,0L1.56,22a.86.86,0,0,1,0-1.21L10.48,12,1.56,3.23A.86.86,0,0,1,1.56,2l.28-.26a.86.86,0,0,1,1.22,0l8.79,8.69,8.72-8.7a.88.88,0,0,1,1.22,0l.26.25a.85.85,0,0,1,0,1.21Z';

  // If the close icon is small, we want to use a heavier icon
  if (size < 18) {
    path =
      'M14.58,12,22,4.61a1.69,1.69,0,0,0,.5-1.21A1.64,1.64,0,0,0,22,2.2L21.74,2a1.7,1.7,0,0,0-2.38,0L12,9.3,4.65,2a1.67,1.67,0,0,0-1.2-.49A1.7,1.7,0,0,0,2.25,2L2,2.24a1.7,1.7,0,0,0-.5,1.2A1.68,1.68,0,0,0,2,4.64L9.48,12,2,19.36a1.69,1.69,0,0,0,0,2.4l.25.25a1.72,1.72,0,0,0,1.2.48A1.67,1.67,0,0,0,4.65,22L12,14.7,19.36,22a1.7,1.7,0,0,0,2.38,0L22,21.8a1.64,1.64,0,0,0,.52-1.2,1.66,1.66,0,0,0-.5-1.21Z';
  }

  return (
    <svg
      id="icon-close"
      data-name="Icon Close"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
    >
      <title>Close</title>
      <path id="close" fill={primaryFill} d={path} />
    </svg>
  );
};

CloseXIcon.defaultProps = {
  primaryFill: 'currentColor',
  size: 21,
};

CloseXIcon.propTypes = {
  primaryFill: PropTypes.string,
};

export const HeartIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="52"
    height="45"
    viewBox="0 0 52 45"
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#FFF"
      strokeWidth="2"
      d="M47.543 21.374c-2.588 2.648-4.82 4.932-9.223 9.442l-1.317 1.35-1.47 1.504c-4.163 4.264-6.338 6.49-8.82 9.029l-.715.732L4.454 21.353c-4.605-4.72-4.606-12.118 0-16.829C6.672 2.254 9.611 1 12.72 1c3.11 0 6.049 1.254 8.268 3.524l4.138 4.25c.217.225.54.359.883.359.342 0 .666-.134.882-.359l4.118-4.229c2.218-2.268 5.157-3.521 8.267-3.521 3.11 0 6.05 1.253 8.267 3.521 4.61 4.716 4.61 12.114 0 16.83z"
    />
  </svg>
);

export const ModalArrow = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="26"
    height="50"
    viewBox="0 0 25.45 48.78"
  >
    <polygon
      fill="currentColor"
      points="24.39 48.78 0 24.39 24.39 0 25.45 1.06 2.12 24.39 25.45 47.72 24.39 48.78"
    />
  </svg>
);

export const ErrorInfoIcon = () => (
  <svg
    height="50"
    viewBox="0 0 51 50"
    width="51"
    xmlns="https://www.w3.org/2000/svg"
  >
    <g fill="#48565E" fillRule="nonzero" transform="translate(.372)">
      <path
        d="M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zm0 46.667c-11.977 0-21.667-9.69-21.667-21.667 0-11.977
            9.69-21.667 21.667-21.667 11.977 0 21.667 9.69 21.667 21.667 0 11.977-9.69 21.667-21.667 21.667z"
      />
      <path d="M25 30.114a2.28 2.28 0 0 0 2.273-2.273V14.773A2.28 2.28 0 0 0 25 12.5a2.28 2.28 0 0 0-2.273 2.273V27.84A2.28 2.28 0 0 0 25 30.114z" />
      <circle cx="25" cy="35.398" r="2.841" />
    </g>
  </svg>
);

export const UGCSearchIcon = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 15"
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.05 11.95a7 7 0 1 1 9.9-9.9 7 7 0 0 1-9.9 9.9zm8.485-4.2a.75.75 0 1 0 0-1.5H7.75V3.464a.75.75 0 1 0-1.5 0V6.25H3.464a.75.75 0 1 0 0 1.5H6.25v2.786a.75.75 0 1 0 1.5 0V7.75h2.785z"
    />
  </svg>
);

export const RightFollowLink = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    xmlnsXlink="https://www.w3.org/1999/xlink"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <defs>
      <path
        id="a"
        d="M14.678 3.503l-6.765 6.855-6.826-6.855L0 4.59l7.913 7.913 7.852-7.943z"
      />
    </defs>
    <use
      fill="#48565E"
      fillRule="nonzero"
      transform="rotate(-90 7.883 8.003)"
      xlinkHref="#a"
    />
  </svg>
);

export const LikesHeart = () => (
  <svg
    xmlns="https://www.w3.org/2000/svg"
    width="24"
    height="20"
    viewBox="0 0 24 20"
  >
    <defs>
      <path
        d="M6.003.072a6.016 6.016 0 0 0-4.24 1.73 5.865 5.865 0 0 0 0 8.378l9.932 9.814a.27.27 0 0 0 .38 0c3.314-3.267 6.625-6.538 9.94-9.805a5.853 5.853
        0 0 0 0-8.37 6.046 6.046 0 0 0-8.48 0l-1.638 1.614-1.655-1.63A6.015 6.015 0 0 0 6.002.072z"
      />
    </defs>
    <g fill="currentColor" fillRule="evenodd">
      <path
        d="M11.885 19.479l4.77-4.706.093-.092c2.428-2.396 3.546-3.499 4.916-4.848a5.353 5.353 0 0 0 0-7.657 5.546 5.546 0 0 0-7.777 0l-1.99 1.958-.35-.345L9.89
          2.16A5.514 5.514 0 0 0 6.003.572a5.514 5.514 0 0 0-3.889 1.587 5.365 5.365 0 0 0 0 7.666l9.77 9.654zm0 0l.161.159a.23.23 0 0 0-.322 0l.16-.16z"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/reactModules/shared/Svgs.js